import { createAsyncThunk } from '@reduxjs/toolkit';
import { ClassServices } from 'Services/axios/Class.Service';
import { checkFilter } from 'Features/Common/CommonUtils';
import { handleApiError } from 'Features/Common/ErrorHandler';
import { toast } from 'react-toastify';

export const fetchClasses = createAsyncThunk(
    'Classes/fetchClasses',
    async (filters) => {
        try {
            let filter = checkFilter(filters);
            const response = await ClassServices.getAll(filter);
            return response.data;
        } catch (error) {
            handleApiError(error);
            throw error;
        }
    }
);

export const submitClasses = createAsyncThunk(
    'Classes/submitClasses',
    async (data) => {
        try {
            const formData = new FormData();
            formData.append('name', data.name);
            formData.append('description', data.description);
            data.banner && formData.append('banner', data.banner);

            let response;
            if (data.id) {
                response = await ClassServices.update(data.id, formData);
            } else {
                response = await ClassServices.create(formData);
            }
            toast.success('Kelas berhasil' + (data.id ? ' diubah' : ' dibuat'), {
                position: toast.POSITION.TOP_RIGHT,
            });
            data.successCallback && data.successCallback();
            return response.data.data;
        } catch (error) {
            handleApiError(error);
            throw error;
        }
    }
);

export const deleteClasses = createAsyncThunk(
    'Classes/deleteClasses',
    async (id) => {
        try {
            const response = await ClassServices.delete(id);
            toast.success(response.data.message, {
                position: toast.POSITION.TOP_RIGHT,
            });
            return id;
        } catch (error) {
            handleApiError(error);
            throw error;
        }
    }
);

export const attachDetachUserToClass = createAsyncThunk(
    'Class/attachDetachUserToClass',
    async (data) => {
        try {
            const formData = new FormData();
            formData.append('membershipId', data.membershipId);
            data.userId.forEach((user, index) => {
                formData.append(`userId[${index}]`, user);
            });
            await ClassServices.attachDetachUserToClass(data.class_id, formData);
            return true;
        } catch (error) {
            handleApiError(error);
            throw error;
        }
    }
);

export const fetchDetailMemberClass = createAsyncThunk(
    'Class/fetchDetailMemberClass',
    async (id) => {
        try {
            const response = await ClassServices.getDetailMemberClass(id);
            return response.data;
        } catch (error) {
            handleApiError(error);
            throw error;
        }
    }
);

export const replicateClass = createAsyncThunk(
    'Class/replicateClass',
    async (id) => {
        try {
            const response = await ClassServices.replicate(id);
            return response;
        } catch (error) {
            handleApiError(error);
            throw error;
        }
    }
);